import React from 'react';
import PropTypes from 'prop-types';

import InputWithIcon from '../input_with_icon'
import './text_field.scss'

export default class TextField extends React.Component
  constructor: (props) -> super(props)

  onBlur: (e) => @props.onBlur?(e.target.value)

  onChange: (e) => 
    @props.onChange?(e.target.value)
    @props.onChangeEvented?(e)

  render: ->
    inputProps = {
      className: @props.className,
      name: @props.field,
      onBlur: @onBlur,
      onChange: @onChange,
      type: (@props.type || 'text'),
      autoCapitalize: "off",
      autoCorrect: "off",
      autoComplete: @props.autoComplete || "off",
      spellCheck: "false"
    }

    if @props.onChange || @props.onChangeEvented
      inputProps.value = (@props.value || '')
    else
      inputProps.defaultValue = (@props.value || '')

    if @props.disabled
      className = "text-field disabled #{@props.className}"
      field = <React.Fragment>
        <input type="hidden" name={@props.field} value={@props.value}/>
        <p className={className}>{@props.value}</p>
      </React.Fragment>
    else if @props.icon
      inputProps.content = { icon: @props.icon }
      field = <InputWithIcon {...inputProps}/>
    else
      field = <input {...inputProps} className="form-control"/>

    <div className='input-group'>{field}</div>

TextField.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.string,
  onChangeEvented: PropTypes.func,
  icon: PropTypes.object,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string
}
